import CategoryPageWrapper from './categoryPageWrapper'

export default CategoryPageWrapper
